import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

const footerSections = [
  {
    title: 'Products',
    links: [
      { label: 'AI Voice IT Support', href: '/ai-voice-agent' },
      { label: 'AI Customer Care', href: '/ai-customer-care' },
      { label: 'Analytics & Chat Agents', href: '/analytics-chat-agents' },
      { label: 'AI Web Chat Integration', href: '/ai-web-chat' },
      { label: 'AI Workflow Automation', href: '/ai-workflow-automation' },
      { label: 'AI Compliance Studio', href: '/ai-compliance-studio' },
      { label: 'Pricing', href: '/pricing' },
    ],
  },
  {
    title: 'Use Cases',
    links: [
      { label: 'Order Status & Returns', href: '/use-cases/order-status' },
      { label: 'Password Reset & Unlock', href: '/use-cases/password-reset' },
      { label: 'Billing & Payments', href: '/use-cases/billing-payments' },
      { label: 'Employee Onboarding', href: '/use-cases/employee-onboarding' },
      { label: 'Case Triage & Agent Assist', href: '/use-cases/case-triage' },
    ],
  },
  // {
  //   title: 'Resources',
  //   links: [
  //     { label: 'Documentation', href: '/docs' },
  //     { label: 'API Reference', href: '/docs' },
  //     { label: 'Blog & Insights', href: '/blog' },
  //     { label: 'Case Studies', href: '/case-studies' },
  //   ],
  // },
  {
    title: 'Company',
    links: [
      { label: 'About Us', href: '/about' },
      { label: 'Careers', href: '/careers' },
      { label: 'Request Demo', href: '/demo' },
      { label: 'Contact Us', href: '/contact' },
    ],
  },
];

const socialLinks = [
  // PLACEHOLDER: replace href values with real social profile URLs
  { label: 'LinkedIn', abbr: 'in', href: 'https://linkedin.com/company/digian-ai' },
  { label: 'Twitter / X', abbr: 'X', href: 'https://twitter.com/digian_ai' },
  { label: 'GitHub', abbr: 'GH', href: 'https://github.com/digian-ai' },
];

const certBadges = [
  'GDPR Compliant',
  'Data Encrypted in Transit & at Rest',
  'Role-Based Access Control',
];

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">

      {/* Main footer grid */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-12">

          {/* Brand column */}
          <div className="md:col-span-2 space-y-5">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-md overflow-hidden bg-gradient-to-br from-indigo-600 to-violet-600 flex items-center justify-center flex-shrink-0">
                <img
                  src={require('../assets/digian-logo.png')}
                  alt="Digian.ai logo"
                  className="w-8 h-8 object-cover"
                />
              </div>
              <span className="font-['Outfit'] font-bold text-xl">digian.ai</span>
            </div>

            <p className="text-slate-400 text-sm leading-relaxed">
              AI-powered digital assistants and data modernization tools for enterprise.
              Voice agents, conversational analytics, and intelligent automation built for scale and security.
            </p>


            {/* Contact */}
            <div className="flex items-center gap-2 text-slate-400 text-sm">
              <Mail className="w-4 h-4 text-indigo-400 flex-shrink-0" />
              <a href="mailto:contact@digian.ai" className="hover:text-white transition-colors">
                contact@digian.ai
              </a>
            </div>
          </div>

          {/* Nav columns */}
          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="font-['Outfit'] font-semibold text-white mb-4 text-sm">{section.title}</h3>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm transition-colors hover:text-white text-slate-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Compliance badges */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-wrap gap-3 mb-8">
            {certBadges.map((badge) => (
              <div
                key={badge}
                className="px-3 py-1.5 rounded-md bg-slate-800 border border-slate-700 text-xs text-slate-400 font-medium"
              >
                🔒 {badge}
              </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
            <p>&copy; {new Date().getFullYear()} Digian.ai. All rights reserved.</p>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
